import { CustomerTelephoneDetails } from '../../models/customer/customer-telephone-details.interface';

export const mockCustomerTelephoneDetails: CustomerTelephoneDetails = {
  Home: '0123456789',
  other: '0123456789',
  work: '0123456789',
};
